export default
{
  AUD: {
    code3: "AUD",
    name: "澳元",
    symbol: "AU$",
  },
  EGP: {
    code3: "EGP",
    name: "埃及鎊",
    symbol: "ج.م",
  },
  RUB: {
    code3: "RUB",
    name: "卢布",
    symbol: "RUB",
  },
  COP: {
    code3: "COP",
    name: "哥伦比亚比索",
    symbol: "COP$",
  },
  CAD: {
    code3: "CAD",
    name: "加元",
    symbol: "C$",
  },
  USD: {
    code3: "USD",
    name: "美元",
    symbol: "$",
    rate: 1,
  },
  EUR: {
    code3: "EUR",
    name: "欧元",
    symbol: "€",
  },
  JPY: {
    code3: "JPY",
    name: "日元",
    symbol: "¥",
  },
  CNY: {
    code3: "CNY",
    name: "人民币",
    symbol: "¥",
  },
  GBP: {
    code3: "GBP",
    name: "英镑",
    symbol: "£",
  },
  INR: {
    code3: "INR",
    name: "印度盧比",
    symbol: "Rs.",
  },
}